import React from "react";
import "./Footer.css";
import PlayAudioSlider from "../PlayAudioSlider/PlayAudioSlider";
import { useDispatch, useSelector } from "react-redux";
import TrackItem from "../TrackItem/TrackItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from "antd";
import { toggleShowAudioLinks } from "../../Redux/AudioSlice";

function Footer() {
  const dispatch = useDispatch();
  const showAudioLinks = useSelector((state) => state.audio.showAudioLinks);
  const audioLinksSelector = useSelector((state) => state.audio.audioLinks);
  const audioLinks = audioLinksSelector || [];

  const handleCloseAudioLinks = () => {
    dispatch(toggleShowAudioLinks());
  };

  return (
    <>
      {showAudioLinks && (
        <div className="audioLinksWrapper">
          <div className="audioLinksHeader">
            <span className="audioLinksHeaderTitle">Danh sách phát</span>
            <Button
              className="audioLinksHeaderCloseBtn"
              shape="circle"
              variant="filled"
              color="default"
              onClick={handleCloseAudioLinks}
            >
              <FontAwesomeIcon icon={faXmark} />
            </Button>
          </div>
          <div className="audioLinks">
            {audioLinks.map((audioLink, index) => (
              <TrackItem
                key={index}
                trackIndex={index}
                trackId={audioLink.audioId}
                trackName={audioLink.name || audioLink.link + " " + index}
                artistName={audioLink.author}
                img={audioLink.trackImg || "https://picsum.photos/200/300"}
                audioLink={audioLink.link}
              />
            ))}
          </div>
        </div>
      )}
      <div className="footerWrapper">
        <PlayAudioSlider />
      </div>
    </>
  );
}

export default Footer;
